import React from "react";
import * as AU from "../style/intro-OmOss-style";
import * as Lib from "../style/lib";
import AtGroup from "../../assets/portraits/hej-andtech.png";
import { BubbleUp } from "../utils/bubble";




export const IntroOmOss: React.FC = () => {

  return (
    <AU.AboutContainer>
      <AU.AboutInnerContainer>

        <AU.ImgContainer style={{ position: "relative" }}>

            <AU.GroupImg
              src={AtGroup}
              alt="Gruppbild på AndTechs medarbetare" />


          <BubbleUp />
        </AU.ImgContainer>

        <Lib.BigH1>Vi tror på samarbete</Lib.BigH1>

        <AU.AboutIntroParagraph>
          Vi är ett gäng nyfikna och nördiga experter som brinner för att hjälpa
          våra kunder växa och utvecklas. Vårt mål är enkelt: att tillsammans
          skapa lösningar som gör verklig skillnad.
          <br /> <br />
          Vi tror på lösningar som håller i längden – därför bygger vi en
          arkitektur som är enkel att förstå och lätt att jobba med. För oss är
          samarbete nyckeln till framgång. Vi gillar att jobba nära våra kunder
          och skapa en atmosfär där alla bidrar. Genom vår öppna och engagerade
          teamkultur blir vi inte bara ett starkt internt team, utan också en
          pålitlig partner för dig.
        </AU.AboutIntroParagraph>

        <AU.ReadMore to="/om-oss" />
      </AU.AboutInnerContainer>
    </AU.AboutContainer>
  );
};
